module.exports = __webpack_public_path__ + "static/media/csv.51ad4628.png";